import request from '@/utils/request'
// 获取短信验证码
export function getSmsCode(data) {
    return request({
      url: '/com/shop/auth/send-sms-code',
      method: 'post',
      data: data
    })
}


//城市树
export function getlistMemberSum(shopid,type) {
  return request({
    url: '/com/shop/im/listMemberSum?shopId='+shopid+'&messageType='+type,
    method: 'get',
    params: {}
  })
}